
import request from '@/utils/request'
import { AxiosResult } from '@/typings/common'

export function roadAreaConfigList(data?: any) {
    return request.post<AxiosResult>('/lbu/api/roadAreaConfig/findByPage', data)
}

export function deleteRoadAreaConfig(data?: any) {
    return request.post<AxiosResult>('/lbu/api/roadAreaConfig/delete', data)
}

export function createRoadAreaConfig(data?: any) {
    return request.post<AxiosResult>('/lbu/api/roadAreaConfig/create', data)
}

export function updateRoadAreaConfig(data?: any) {
    return request.post<AxiosResult>('/lbu/api/roadAreaConfig/update', data)
}

export function regionList(data?: any) {
    return request.post<AxiosResult>('/fbu/api/report/region/list', data)
}

export function detailRoadAreaConfig(data?: any) {
    return request.post<AxiosResult>('/fbu/api/report/region/detail', data)
}

/**
 *路区维度查看客户(全国销售部客户查询)
 */
export function findByRoadAreaConfig(data: any) {
  return request.post<AxiosResult, AxiosResult>('/lbu/api/customer/findByRoadAreaConfig', data)
}
